import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppUser } from '../models/appUser';
/**
 * - use this to store ui related common values
 *      Eg: sidebar state
 */
const AppSlice = createSlice({
  name: 'app-state',
  initialState: {
    isTrigger: false,
    isLoading: false,
    user: undefined,
    snackBar: {
      visibale: false,
      severity: 'success',
      message: null
    }
  } as { isTrigger: boolean, isLoading: boolean; user?: AppUser, 
    snackBar: {visibale: boolean, message: string | null, severity: string}},
  reducers: {
    showLoader: (state) => {
      state.isLoading = true;
      return state;
    },
    hideLoader: (state) => {
      state.isLoading = false;
      return state;
    },
    setUser: (state, action: PayloadAction<AppUser | undefined>) => {
      state.user = action.payload;
    },
    toggleSnackBarOpen: (state, action: PayloadAction<{message : string, severity: string}>) => {
      state.snackBar.visibale = true;
      state.snackBar.message = action.payload.message;
      state.snackBar.severity = action.payload.severity;
      
    },
    toggleSnackBarClose: (state) => {
      state.snackBar.visibale = false;
      state.snackBar.message = null;
    },
    triggerFunction: (state, action: PayloadAction<{isTrigger : boolean}>) => {
      state.isTrigger = action.payload.isTrigger;
    }
  },
});

const { reducer, actions } = AppSlice;

export const AppActions = actions;
export const AppReducer = reducer;
